export default "__VITE_ASSET__D1ujMKw___"